import { useStoreMap } from 'effector-react'
import * as mainBalance from '~/entities/MainBalance/model'
import { CURRENCY } from '~/shared/config/constants'
import { parseSumForUi } from '~/shared/lib/utils'
import { ProgressBlock } from '~/shared/ui/Loaders'
import { TitleWrapper, Title, Balance, Currency } from './styled'

type AdditionalBalanceHeadingProps = {
  balanceType: string
  title: string
}

export function AdditionalBalanceHeading({
  balanceType,
  title,
}: AdditionalBalanceHeadingProps) {
  const isPending = useStoreMap(mainBalance.getAllBalancesFx.pending, (v) => v)

  const amount = useStoreMap(mainBalance.$allBalances, (balances) => {
    const balance = balances.find((b) => b.getBalanceType() === balanceType)
    return balance?.getAmount() ?? 0
  })

  if (isPending) return <ProgressBlock height={80} />

  return (
    <TitleWrapper>
      <Title>{title}</Title>
      <Balance>
        {parseSumForUi(amount)}&#x20;
        <Currency>{CURRENCY}</Currency>
      </Balance>
    </TitleWrapper>
  )
}
